import { render } from "./ExtraQuestionCard.vue?vue&type=template&id=754d2461"
import script from "./ExtraQuestionCard.vue?vue&type=script&lang=js"
export * from "./ExtraQuestionCard.vue?vue&type=script&lang=js"

import "./ExtraQuestionCard.vue?vue&type=style&index=0&id=754d2461&lang=scss"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__